import { Outlet, useNavigate } from "react-router-dom";
import { Timer, Send, Calendar } from "lucide-react";
import { useAuthCache, useSettingsCache } from "@/shared/cache";
import { DataProvider } from "@/v2/contexts/DataProvider";
import { ActionQueueProvider } from "@/v2/contexts/ActionQueueProvider";
import { TimerProvider } from "@/v2/contexts/TimerProvider";
import { AppShell } from "@/v2/components/AppShell";
import type { NavItem } from "@/v2/components/MobileBottomNav";

const navItems: NavItem[] = [
	{ path: "/tracked", label: "Tracked", icon: Timer },
	{ path: "/exported", label: "Exported", icon: Send },
	{ path: "/calendar", label: "Calendar", icon: Calendar },
];

export default function V2AttorneyLayout() {
	const { auth } = useAuthCache();
	const { settings: _settings } = useSettingsCache(); // TODO: use for prof_type display
	const navigate = useNavigate();

	return (
		<TimerProvider>
			<DataProvider>
				<ActionQueueProvider>
					<AppShell
						navItems={navItems}
						userInitials={auth.initials}
						userDisplayName={auth.displayName}
						userEmail={auth.email}
						showRoleSwitcher={auth.isAdmin}
						currentRole="attorney"
						onRoleSwitch={() => navigate("/admin")}
					>
						<Outlet />
					</AppShell>
				</ActionQueueProvider>
			</DataProvider>
		</TimerProvider>
	);
}
